import React from 'react';

import NextImage from 'next/image';

import HIGH from './assets/high.svg';
import LOW from './assets/low.svg';
import MEDIUM from './assets/medium.svg';

const PRESSURE_ICONS = {
  LOW,
  HIGH,
  MEDIUM,
};

export interface IPressureIconProps extends React.SVGProps<SVGSVGElement> {
  value: keyof typeof PRESSURE_ICONS;
  width?: number | `${number}`;
  height?: number | `${number}`;
}

export const AirPressureIcon = ({ value, height = '32', width = '32' }: IPressureIconProps) => {
  const src = PRESSURE_ICONS[value];
  return src ? (
    <NextImage alt="Weather Condition Icon" width={width} height={height} src={src} />
  ) : (
    <></>
  );
};
